// extracted by mini-css-extract-plugin
export var footer = "_l0-0";
export var inherit = "_l0-1";
export var input = "_l0-2";
export var modalContent = "_l0-3";
export var quillEditor = "_l0-4";
export var subtitle = "_l0-5";